var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_4940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52332 9.99999L13.6483 5.87499L12.47 4.69666L7.16665 9.99999L12.47 15.3033L13.6483 14.125L9.52332 9.99999Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_4940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20.5 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLeft);
export default __webpack_public_path__ + "static/media/page-left.f8442d7e0ea6d6e118a695471c8c44af.svg";
export { ForwardRef as ReactComponent };